module.exports = __webpack_public_path__ + "static/media/Pool-area.0fdb7539.jpg";